import type { FormatLocale } from '#layers/base/public';
import type { CalendarViewMode } from '#layers/listing/constants/calendar';
import type { CalendarRange } from './build-calendar-range-filter';
import { getDateTimeFormat, toNativeDate } from '#layers/base/public';
import { CalendarViewModes } from '#layers/listing/constants/calendar';

export function formatCalendarTitle(view: CalendarViewMode, { start, end }: CalendarRange, locale: FormatLocale): string {
	switch (view) {
		case CalendarViewModes.Year:
			return start.toLocaleString(locale, { year: 'numeric' });
		case CalendarViewModes.Day:
			return start.toLocaleString(locale, { month: 'long', day: 'numeric', year: 'numeric' });
		case CalendarViewModes.Week: {
			const formatter = getDateTimeFormat(locale, { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
			return formatter.formatRange(toNativeDate(start.toZonedDateTime('UTC')), toNativeDate(end.toZonedDateTime('UTC')));
		}
		case CalendarViewModes.Month:
		case CalendarViewModes.List: {
			// Uses the middle date, since the Month grid also shows days of the previous and next months.
			const midDay = Math.floor(start.until(end).total({ unit: 'days' }) / 2);
			return start.add({ days: midDay }).toLocaleString(locale, { month: 'long', year: 'numeric' });
		}
	}
}
